<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">  
		<leftnav  mkcode="D" itemcode="D-ZHFZ"  :smScrennFull="true"></leftnav> 
		<!-- 弹框 -->	
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->
		<div class="por" style="background-color: #041034;height:100%;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true">{{userdata.cityText}}{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<daswiperNav :title="title" :indexnum="3" navcode="JZL"  :fulltitle="true"></daswiperNav>
				<div class="indexflex jingzhegnli"> 
					<div class="col2h colbox transparentbg">
						<div class="jzl_amount ">
							<h3 class="jzl_title">2016-2020金融机构人民币存款余额</h3>
							<div id="jzl_echartbar"></div>
						</div>
						<div class="jzl_amount">
							<h3 class="jzl_title">2016-2020金融机构人民币贷款余额</h3>
							<div id="jzl_echartline"></div>
						</div>
					</div>
					<div class="col5 colbox jzl_center">
						<div class="jzl_rank">
							<h3 class="jzl_rankh3">全国排名 <span class="orgfont">{{pagedata.gdp.all}}</span> </h3>
							<h3 class="jzl_rankh3">全省排名 <span class="orgfont">{{pagedata.gdp.province}}</span></h3>
						</div>
					 <div class="jzl_centerbg" :key="i" v-for="(list,i) in pagedata.field">
							<div class="jzl_centerlist1">
							<h2>GDP</h2> 
							<h3 class="orgfont">{{list.jj0101}}<span class="jzl_comfont">{{list.jj0101_text.split(',')[1]}}</span></h3>
							</div>
							<div class="jzl_centerlist2">
								<h3 class="orgfont">{{list.jj0102 == null?'0':list.jj0102}}<span class="jzl_comfont">{{list.jj0102_text.split(',')[1]}}</span></h3>
							<h3>人均GDP</h3>
							</div>
							<div class="jzl_centerlist3"> 
								<h3 class="orgfont">{{list.cz0101}}<span class="jzl_comfont">{{list.cz0101_text.split(',')[1]}}</span></h3> 
							<h3>财政收入</h3>
							</div>
							<div class="jzl_centerlist4">
								<h3 class="orgfont">{{list.sh0101}}<span class="jzl_comfont">{{list.sh0101_text.split(',')[1]}}</span></h3>
							<h3>人均可支配收入</h3>
							</div>
							<div class="jzl_centerlist5"> 
								<h3 class="orgfont">{{list.wm0101}}<span class="jzl_comfont">{{list.wm0101_text.split(',')[1]}}</span></h3>
							<h3>进出口总额</h3>
							</div>
						</div>
					</div>
					<div class="col2h colbox transparentbg">
						<div class="jzl_amount">
							<h3 class="jzl_title">人口现状</h3>
							<div class="jzl_circlefont jzl_circlefont1 flexcss" v-for="list in pagedata.population">
								<div class="jzl_circlefont_list" >
								<div class="jzl_circlefont_listbg">
								<p class="purplefont">{{list.rk0101}}<span class="jzl_comfont">{{list.rk0101_text.split(',')[1]}}</span></p>
							</div>
							<p class="jzl_circlefont_bot">{{list.rk0101_text.split(',')[0]}}</p> <!-- {{pagedata.invest.unit.split('、')[1]}} -->
							</div>
							<div class="jzl_circlefont_list">
								<div class="jzl_circlefont_listbg">
								<p class="purplefont">{{list.rk0501}}<span class="jzl_comfont">{{list.rk0501_text.split(',')[1]}}</span></p>
							</div> 
							<p class="jzl_circlefont_bot">{{list.rk0501_text.split(',')[0]}}</p> 
							</div>
							<div class="jzl_circlefont_list">
								<div class="jzl_circlefont_listbg">
								<p class="purplefont">{{list.rk0505 == null?'0':list.rk0505}}<span class="jzl_comfont">{{list.rk0505_text.split(',')[1]}}</span></p>
							</div>
							<p class="jzl_circlefont_bot"> {{list.rk0505_text.split(',')[0]}} </p>  
							</div>
							</div> 
						</div>
						<div class="jzl_amount">
							<h3 class="jzl_title">技术现状</h3>
							<div class="jzl_circlefont jzl_circlefont2 flexcss"  v-for="list in pagedata.tech">
								
								<div class="jzl_circlefont_list">
									<div class="jzl_circlefont2_listbg">
									<p class="pinkfont">{{list.kx0101}}<span class="jzl_comfont">{{list.kx0101_text.split(',')[1]}}</span></p>
								</div> 
								<p class="jzl_circlefont_bot">{{list.kx0101_text.split(',')[0]}} </p> 
								</div>
								<div class="jzl_circlefont_list">
									<div class="jzl_circlefont2_listbg">
									<p class="pinkfont">{{list.kx0801 == null?'0':list.kx0801}}<span class="jzl_comfont">{{list.kx0801_text.split(',')[1]}}</span></p>
								</div> 
								<p class="jzl_circlefont_bot">{{list.kx0801_text.split(',')[0]}} </p> 
								</div>
								<div class="jzl_circlefont_list">
									<div class="jzl_circlefont2_listbg">
									<p class="pinkfont">{{list.kx0802 == null?'0':list.kx0802}}<span class="jzl_comfont">{{list.kx0802_text.split(',')[1]}}</span></p>
								</div> 
								<p class="jzl_circlefont_bot">{{list.kx0802_text.split(',')[0]}}</p> 
								</div>  
							</div>
						</div>
						<div class="jzl_amount">
							<h3 class="jzl_title">2016-2020年规上工业企业统计</h3>
							<div id="jzl_echartlinebar"></div>
						</div>
					</div>
					<div class="jzl_bottom" style="position:relative;top:-30px;">
						<div class="jzl_bottombox flexcss" v-for="list in  pagedata.field">
						<div class="jzl_bottom_list">
							<h3>{{pagedata.jy0415.text}}<span class="pinkfont pinkfont1">{{list.jy0415== null?'0':list.jy0415}}</span><span class="jzl_comfont">人</span></h3>
							<div class="jzl_bottom_list1"> 
									<h4 class="jzl_bottom_rank1">全国排名 <span class="pinkfont pinkfont1">{{pagedata.jy0415.all}}</span> </h4>
									<h4 class="jzl_bottom_rank">全省排名 <span class="pinkfont pinkfont1">{{pagedata.jy0415.province}}</span></h4>
							</div>
						</div>
						<div class="jzl_bottom_list">
							<h3>{{pagedata.gk0101.text.substring(0,7)}}<span class="pinkfont pinkfont1">{{list.gk0101== null?'0':list.gk0101}}</span><span class="jzl_comfont">km²</span></h3>
							<div class="jzl_bottom_list1"> 
									<h4 class="jzl_bottom_rank1">全国排名 <span class="pinkfont pinkfont1">{{pagedata.gk0101.all}}</span> </h4>
									<h4 class="jzl_bottom_rank">全省排名 <span class="pinkfont pinkfont1">{{pagedata.gk0101.province}}</span></h4>
							</div>
						</div>
						<div class="jzl_bottom_list">
							<h3>{{pagedata.gk0103.text}} <span class="pinkfont pinkfont1">{{list.gk0103== null?'0':list.gk0103}}</span><span class="jzl_comfont">km²</span></h3>
							<div class="jzl_bottom_list1"> 
									<h4 class="jzl_bottom_rank1">全国排名 <span class="pinkfont pinkfont1">{{pagedata.gk0103.all}}</span> </h4>
									<h4 class="jzl_bottom_rank">全省排名 <span class="pinkfont pinkfont1">{{pagedata.gk0103.province}}</span></h4>
							</div>
						</div>
						</div>
					</div> 
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
	import mappng from '../../assets/images/mapbg.png';
	export default {
		name: 'jingzhegnli',
		data() {
			return {
				isCollapse:false,
				isFullscreen: false,
				direction:"ltr",  //btt
				direction2:"btt",  //btt
				 drawer: false,
					drawer2: false,
					modal:false,	
				title: "竞争力数字大屏",bgcolor:"#041034",
				usernotionlistsave: [],
				userdata: {},
				pagedata:{
					gdp:{all:1,province:1},
					gk0102:{all:1,province:1},
					field:[{jj0101_text:'',jj0102_text:'',cz0101_text:'',sh0101_text:'',wm0101_text:''}],
					jy0415:{text:''},
					gk0101:{text:''},
					gk0103:{text:''},
					population:[{rk0101_text:'',rk0501_text:'',rk0505_text:''}],
					tech:[{kx0101_text:'',kx0801_text:'',kx0802_text:'',}],
				
				}, 
				islogin: false,
				flag: true,
				swipernum: 3,
				listdata: [],
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType:[],
				startCharts: null,
				//假数据 
			}
		},
		props: {
			msg: String,
		},
		mounted() {
			document.getElementById('app').style.background=this.bgcolor;
			this.userdata = this.getuseriformation();
			// console.log(this.userdata);
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			this.getajasdata(); 
		},
		methods: {
			getajasdata(){
				var _this=this;
				// this.bus.$emit('loading', true);
				console.log(this.title);
				this.$axios.get(this.$api.cyl.govsaaschart.competitive(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log("ajaxres",res); 
					_this.pagedata = res.data.data;
					console.log(_this.pagedata);
				var 	echartbardata = res.data.data.deposit.list;
				var 	echartlindata = res.data.data.loan.list; 
				var enterprisedata = res.data.data.gy0102.list; //利税总额
				var enterprisedata2 = res.data.data.gy0101.list;  //企业总数
					_this.echartbarFun('jzl_echartbar',echartbardata);
					_this.echartlinFun('jzl_echartline',echartlindata);
					_this.echartlinebarFun('jzl_echartlinebar',enterprisedata, enterprisedata2);
					_this.bus.$emit('loading', false); 
				}).catch(function (error) { 
					// 请求失败处理 console.log(error);
				});  
			},  
			
			
			//2016-2020金融机构人民币存款余额
			echartbarFun(el,data){
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var  echartbar= echarts.init(document.getElementById(el)); 
				var _this = this,xdata=[],ydata=[];
				for(var i=0;i<data.length;i++){
					xdata.push(data[i].name);
					ydata.push(data[i].value); 
					
				}
				// console.log(xdata,ydata);
				var 	option = {
				  tooltip: {
							show:true,
				    trigger: 'axis', 
							// formatter: function (params) {
							//         var result = ''
							//         var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
							//         result += dotHtml + ' GDP（亿元） ' + params[0].data + "</br>" + dotHtml + ' GDP增速（%） ' + params[1].data;
							//         return result
							//     }
				  },  
				  legend: {show:false },
						grid:{  x:'15%', y:'15%', x2:'10%',y2:'15%' },
				  xAxis: [
				    {
				      type: 'category',
				      data: xdata,
				      axisPointer: {
				        type: 'shadow'
				      },
										axisLine: {
											show:true,
										lineStyle:{
											color:'#eee',
										}
										},
										axisLabel:{
													formatter:function (value, index) {return value+'年'; },  // x轴加单位
										},
				    }
				  ],
				  yAxis: [
				    { 
				      type: 'value',
				      name: '亿元',
				      // min: 0,
				      // max: 60,  
				      axisTick:{"show":true },		//刻度线
										axisLine: {														//轴线
											show:true,
										lineStyle:{
											color:'#eee',
										}
										},  
										splitLine:{show:false}, //不显示网格线
				    }, 
				  ],
				  series: [ 
				    {
				      name: 'GDP',
				      type: 'pictorialBar',
										barWidth:32,
									itemStyle: {
										borderRadius:[30,30,0,0],
											color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
													{ offset: 0, color: '#fff' },
													{ offset: 0.5, color: '#9692c1' },
													{ offset: 1, color: '#48456d' }
											])
									},
									emphasis: {
											itemStyle: {
													color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
															{ offset: 0, color: '#fff' },
															{ offset: 0.5, color: '#9692c1' },
															{ offset: 1, color: '#48456d' }
													])
											}
									},
										// barCategoryGap: '40%',
										symbol: 'triangle',
										label:{
										  normal:{ 
										  show: true, 
										  position: 'top',  //显示顶部数据
												color : '#fff',  
										   }
										},
				      data: ydata,
				    }, 
				  ]
				};
				echartbar.setOption(option); 
			},
			
			//2016-2020金融机构人民币贷款余额
			echartlinFun(el,data){
				var  echartlin= echarts.init(document.getElementById(el));
				var _this = this,xdata1=[],ydata1=[];
				for(var i=0;i<data.length;i++){
					// if(data[i].name=='2020'){  //手动填2020年数据
					// 	data[i].value =6328.07;
					// }
					xdata1.push(data[i].name);
					ydata1.push(data[i].value); 
				}
				// console.log(xdata1,ydata1);
				var	option = {
					tooltip: {
					  trigger: 'axis',  
					},
					grid:{  x:'15%', y:'10%', x2:'10%',y2:'25%' },
			  xAxis: {
			    type: 'category',
			    boundaryGap: false,
							axisLine: {
								show:true,
							lineStyle:{
								color:'#eee',
							}
							},
							axisLabel:{
										formatter:function (value, index) {return value+'年'; },  // x轴加单位
							},
			    data: xdata1,
			  },
			  yAxis: {
							name:'亿元',
			    type: 'value',
							// min: 800,
							// max: 3600,  
							// interval: 1500,		//步长值
							splitLine:{show:false}, //不显示分割线
							axisLine: {
								show:false,
							lineStyle:{
								color:'#ff052f',
							}
							},
							axisTick:{"show":true },		//刻度线
							axisLine: {														//轴线
								show:true,
							lineStyle:{
								color:'#eee',
							}
							}, 
			  },
			  series: [
			    {
			      data: ydata1,
			      type: 'line',
									symbol:'emptyCircle',
			      areaStyle: {},
									label:{
									  normal:{ 
									  show: true, 
									  position: 'top',  //显示顶部数据
											color : '#fff',
									   }
									}, 
									itemStyle:{
										normal:{
											// borderWidth:2,
											// color:'#1890ff',
											  color:'#48456d',
													lineStyle:{
													color:'#9692c1' //改变折线颜色
													}
										}
									},
			    }
			  ]
			};
				echartlin.setOption(option);
			},
			
			 //2016-2020年规上工业企业统计
			 echartlinebarFun(el,data,data1){
			 	var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			 	var  echartlinebar= echarts.init(document.getElementById(el)); 
					var _this = this,xdata1=[],ydata1=[],xdata=[],ydata=[];
					//折线图xy轴数据
					for(var i=0;i<data.length;i++){ 
						xdata1.push(data[i].name);
						ydata1.push(data[i].value); 
						
					}  
					//柱形图xy轴数据
					for(var x=0;x<data1.length;x++){
						
						// if(data1[x].name=="2020"){ //因为手动改2020数据
						// 	data1[x].value = 2540; 
						// }
						xdata.push(data1[x].name);
						ydata.push(data1[x].value); 
					}  
					// console.log(ydata,xdata,ydata1,xdata1);
			 	var 	option = {
			 	  tooltip: {
			 	    trigger: 'axis', 
			 				formatter: function (params) {
			 				        var result = ''
			 				        var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:8px;height:8px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
			 				        var dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:8px;height:8px;background-color:#ffbb1c"></span>'    // 定义第一个数据前的圆点颜色
																result += dotHtml2 + ' 利税总额（亿元）' + params[0].data + "</br>" + dotHtml + ' 企业总数 （个）' + params[1].data;
			 				        return result
			 				    }
			 	  }, 
			 	 // legend: {top: '5%',left:'5%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:8,itemHeight:8, },	//图例圆形icon:'circle'
			 		legend: [				//设置两组图例样式
							{
							data:  ['企业总数'],
							textStyle:{color:"#eee",fontSize:12,},
							icon:'rect',  //图例样式 圆点circle 矩形rect
							itemWidth:10,
							itemHeight:9, 
							left:'3%',},
							{
								data:  ['利税总额'],
							textStyle:{color:"#eee",fontSize:12,itemWidth:10,itemHeight:10,},
							icon:'rect',  //图例样式 圆点circle 矩形rect
							itemWidth:10,
							itemHeight:1,
							top:'10%',
							left:'3%',
							},
						],  
							grid:{  x:'5%', y:'20%', x2:'15%',y2:'15%' },
			 	  xAxis: [
			 	    {
			 	      type: 'category',
			 	      data:xdata1,
			 	      axisPointer: {
			 	        type: 'shadow'
			 	      },
			 							axisLine: {
			 								show:true,
			 							lineStyle:{
			 								color:'#eee',
			 							}
			 							},
											axisLabel:{
														formatter:function (value, index) {return value+'年'; },  // x轴加单位
											},
			 	    }
			 	  ],
			 	  yAxis: [
								{
										name: ' ',
								  type: 'value', 
								  // min:0,				//最小值
								  // max: 10,			//最大值
								  // interval: 2,		//步长值
										axisTick:{"show":false }, //刻度线
										splitLine:{ show:false}, //不显示网格
										axisLine: {show:false,  lineStyle:{ color:'#eee', } }, 		//轴线 
										axisLabel : {   formatter: function(){return ""; } } }, //不显示y轴数据  
			 	    { 
			 	      type: 'value',
			 	      name: '亿元',
			 	      // min: 3500,
			 	      // max: 8500,  
											// interval: 1000,		//步长值
			 	      axisTick:{"show":true },		//刻度线
			 							axisLine: {														//轴线
			 								show:true,
			 							lineStyle:{
			 								color:'#eee',
			 							}
			 							},   
			 							splitLine:{show:false}, //不显示网格线
			 	    },
			 	    
			 	  ],
			 	  series: [ 
								{
								  name: '利税总额',
								  type: 'line',
								  yAxisIndex: 1,
										color:'#f39800',
										itemStyle:{
											normal:{
												lineStyle:{
													type:""				//折线类型
												}
											}
										},
								  data: ydata1,
								},
			 	    {
			 	      name: '企业总数',
			 	      type: 'bar',
			 							barWidth:30,
			 						barWidth:32,
			 						showBackground: true,
			 						itemStyle: {
			 							borderRadius:[30,30,0,0],
			 								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			 										{ offset: 0, color: '#fff' },
			 										{ offset: 0.5, color: '#9692c1' },
			 										{ offset: 1, color: '#48456d' }
			 								])
			 						},
			 						emphasis: {
			 								itemStyle: {
			 										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			 											{ offset: 0, color: '#fff' },
			 											{ offset: 0.5, color: '#9692c1' },
			 											{ offset: 1, color: '#48456d' }
			 										])
			 								}
			 						},
			 							label:{
			 							  normal:{ 
			 							  show: true, 
			 							  position: 'top',//顶部显示数据
			 									color : '#fff',
													formatter: '{@score}'+'个'
			 							   }
			 							},
			 	      data:ydata,
			 	    }, 
			 	  ]
			 	};
			 	echartlinebar.setOption(option); 
			 },
			
		}
	}
</script>

<style scoped="scoped">
	#app{
		background-color: #041034;
	}
	@import url("../../css/dataswiper.css");
</style>
